'use client';

import {
  CreateSupportTicketRequest,
  UserSupportTicketCategory,
} from '@trucksmarter/shared';
import { makeClientSideRequest } from './http-client';
import Endpoint from '../endpoints';

export default function createSupportTicket(
  category: UserSupportTicketCategory,
  description: string,
) {
  return makeClientSideRequest<
    CreateSupportTicketRequest,
    { isSuccess: boolean }
  >(
    Endpoint.UsersCreateSupportTicket,
    { category, description },
    {
      defaultErrorMessage:
        'Failed to create support ticket. If the issue persists, please reach out to support@trucksmarter.com.',
    },
  );
}
